import { parse } from 'cookie';
import Cookies, { CookiesOption } from 'cookies-ts';

export const THEME_COOKIE_KEY = 'vc_bo_theme';
export const COOKIE_ACCESS_TOKEN = 'access_token';
export const COOKIE_ID_TOKEN = 'id_token';
export const TOKEN_EXPIRES_IN = 'expires_in';

export const getCookieObject = () => {
  return parse(document.cookie);
};

export const setCookie = (
  key: string,
  value: string | null,
  option?: CookiesOption
) => {
  const cookies = new Cookies();
  cookies.set(key, value, option);
  return cookies;
};

export const getCookie = (key: string) => {
  const cookies = new Cookies();
  return cookies.get(key);
};

export const getAccessToken = () => {
  return getCookie(COOKIE_ACCESS_TOKEN);
};

export const setAccessToken = (value: string, option: CookiesOption) => {
  return setCookie(COOKIE_ACCESS_TOKEN, value, option);
};

export const setIDToken = (value: string, option: CookiesOption) => {
  return setCookie(COOKIE_ID_TOKEN, value, option);
};

export const removeCookie = (key: string, option?: CookiesOption) => {
  const cookies = new Cookies();
  cookies.remove(key, option);
  return new Cookies();
};

export const removeAccessToken = (option?: CookiesOption) => {
  return removeCookie(COOKIE_ACCESS_TOKEN, option);
};

export const removeIDToken = (option?: CookiesOption) => {
  return removeCookie(COOKIE_ID_TOKEN, option);
};
